import styles from "./page.module.css";
import Header from "components/header/Header";
import Footer from "components/footer/Footer";
import commonStyles from "components/commonStyle/commonStyle.module.css";

import EmployBookingManagement from "./BookingManagement/BookingManagement";
import WorkTimeManagement from "./workTime/WorkTimeManagment";
import CustomerTable from "./customerManagment/customerManagment";
import { useEffect, useState } from "react";
import LogedinHeaderComponent from "components/logedinHeaderComponent/logedinHeaderComponent";
import { checkSession } from "services/userLogin/check-session";
import { useNavigate } from "react-router-dom";
import AdministrationManagement from "./administration/administrationManagment";
import { logout } from "services/userLogin/logout";

const handleLogout = (navigate: any) => {
  logout();
  navigate('/reservierungsportal');
};

export default function EmployPage() {
  const [isAdmin, setIsAdmin] = useState(false);

  const sections = [
    { id: "Buchungsverwaltung", label: "Buchungsverwaltung" },
    { id: "workTime", label: "Öffnungszeiten" },
    { id: "customManagement", label: "Nutzerverwaltung" },
    ...(isAdmin ? [{ id: "administration", label: "Administration" }] : []),
  ];

  const [activeSection, setActiveSection] = useState<string>(sections[0].id);
  const navigate = useNavigate();

  const handleSectionClick = (tabId: string) => {
    setActiveSection(tabId);
    window.history.pushState({ tabId }, "", `#${tabId}`);
  };

  const verifySession = async () => {
    try {
      const sessionData = await checkSession();
      if (sessionData.session_active) {
        const { id, is_customer, is_employee, is_profile_completed, is_password_completed, has_kid, is_admin, is_statistic } = sessionData.user_data;
        if (!is_customer) {
          if (is_employee) {
            setIsAdmin(is_admin);
            if (is_password_completed) {
              if (is_statistic) {
                navigate('/reservierungsportal/StatisticPage', { replace: true });
              } else {
                navigate('/reservierungsportal/EmployHomePage', { replace: true });
              }
            } else {
              navigate('/reservierungsportal/EmploySetPassword', { replace: true });
            }
          } else {
            navigate('/reservierungsportal');
          }
        } else {
          if (!is_profile_completed) {
            navigate("/reservierungsportal/compliatProfile", { replace: true });
          } else if (!has_kid) {
            navigate("/reservierungsportal/NewkidsProfile", { replace: true });
          } else {
            navigate("/reservierungsportal/CustomerHomePage", { replace: true });
          }
        }
      } else {
        navigate('/reservierungsportal', { replace: true });
      }
    } catch (error) {
      console.error("Fehler bei der Sitzungsprüfung:", error);
    }
  };

  useEffect(() => {
    verifySession();
  }, [isAdmin]);

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      const tabId = event.state?.tabId || sections[0].id;
      setActiveSection(tabId);


    };

    window.addEventListener("popstate", handlePopState);

    const initialTabId = window.location.hash.substring(1) || sections[0].id;
    setActiveSection(initialTabId);

    if (!window.location.hash) {
      window.history.replaceState({ tabId: initialTabId }, "", `#${initialTabId}`);
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [sections]);

  return (
    <div className={styles.page}>
      <Header>
        <LogedinHeaderComponent sections={sections} activeSection={activeSection} onTabChange={handleSectionClick} isWithSearch={true} />
      </Header>
      <main className={styles.main}>
        {activeSection === "Buchungsverwaltung" && <section className={commonStyles.sectionContainer}>
          <EmployBookingManagement />
        </section>}
        {activeSection === "workTime" && <section className={commonStyles.sectionContainer} >
          <WorkTimeManagement />
        </section>}
        {activeSection === "customManagement" && <section className={commonStyles.sectionContainer} >
          <CustomerTable />
        </section>}
        {activeSection === "administration" && (
          <section className={commonStyles.sectionContainer}>
            <AdministrationManagement />
          </section>
        )}
      </main>
      <Footer />
    </div>
  );
}
